import { RegistrationPurpose } from '@commenda/types/src/registration/types';
import { Country, RegistrationValidationStatus } from '@prisma/client';
import * as RPNInput from 'react-phone-number-input';

// TODO: (ADARSH) => Think ABout how utils will consume kakashi components
type CountryCode = RPNInput.Country;

type TBadgeVariant =
  | 'gray'
  | 'error'
  | 'warning'
  | 'success'
  | 'blue'
  | 'success-solid'
  | 'error-solid'
  | 'warning-solid'
  | 'info-solid'
  | 'gray-solid';

export class RegistrationHelper {
  static REGISTRATION_VALIDATION_STATUS_MAP: Record<
    RegistrationValidationStatus,
    string
  > = {
    [RegistrationValidationStatus.ACTIVE]: 'Active',
    [RegistrationValidationStatus.INVALID]: 'Invalid',
    [RegistrationValidationStatus.PENDING]: 'Pending',
    [RegistrationValidationStatus.INACTIVE]: 'Expired',
  };

  static US_IRS_E_SERVICES_INTERNAL_IDENTIFIER = 'US_IRS_E_SERVICES';

  static US_IRS_E_SERVICES_PORTAL_URL = 'https://www.irs.gov/e-services';

  static getRegistrationValidationStatusOptions() {
    return Object.entries(this.REGISTRATION_VALIDATION_STATUS_MAP).map(
      ([key, value]) => ({
        value: key as RegistrationValidationStatus,
        label: value,
      })
    );
  }

  static getRegistrationValidationStatus(
    status: RegistrationValidationStatus
  ): string {
    return this.REGISTRATION_VALIDATION_STATUS_MAP[status];
  }

  static getRegistrationCountry(country: Country): CountryCode {
    return country as CountryCode;
  }

  static getRegistrationPurposeBadgeVariant(
    purpose: RegistrationPurpose
  ): TBadgeVariant {
    switch (purpose) {
      case RegistrationPurpose.INCOME_TAX:
        return 'blue';
      case RegistrationPurpose.INDIRECT_TAX:
        return 'success-solid';
      case RegistrationPurpose.PAYROLL:
        return 'success';
      case RegistrationPurpose.CORPORATE_REGISTRY:
        return 'info-solid';
      case RegistrationPurpose.SOCIAL_SECURITY:
        return 'warning';
      case RegistrationPurpose.TRADE:
        return 'warning-solid';
      case RegistrationPurpose.OTHER:
        return 'gray';
      default:
        return 'gray-solid';
    }
  }

  static getRegistrationStatusBadgeVariant(
    status: RegistrationValidationStatus
  ): TBadgeVariant {
    switch (status) {
      case RegistrationValidationStatus.ACTIVE:
        return 'success-solid';
      case RegistrationValidationStatus.INACTIVE:
        return 'error-solid';
      case RegistrationValidationStatus.PENDING:
        return 'warning-solid';
      case RegistrationValidationStatus.INVALID:
        return 'error-solid';
      default:
        return 'gray-solid';
    }
  }
}
